import { Module, MutationTree, ActionTree, GetterTree } from "vuex";

export class i18nState {
  locale: dpost.i18n.language = "ko";
  fallbackLocale: dpost.i18n.language = "ko";
}
const Mutations: MutationTree<i18nState> = {
  updateLocale(state: i18nState, payload: dpost.i18n.language) {
    state.locale = payload;
  },
  updateFallbackLocale(state: i18nState, payload: dpost.i18n.language) {
    state.fallbackLocale = payload;
  },
};
const Actions: ActionTree<i18nState, any> = {
  updateLocale({ commit }, payload: dpost.i18n.language) {
    commit("updateLocale", payload);
  },
  updateFallbackLocale({ commit }, payload: dpost.i18n.language) {
    commit("updateFallbackLocale", payload);
  },
};
const Getters: GetterTree<i18nState, any> = {
  getLocale: (state: i18nState) => (): dpost.i18n.language => {
    return state.locale;
  },
  getFallbackLocale: (state: i18nState) => (): dpost.i18n.language => {
    return state.fallbackLocale;
  },
};

const module: Module<i18nState, any> = {
  namespaced: true,
  state: new i18nState(),
  mutations: Mutations,
  actions: Actions,
  getters: Getters,
};

export default module;
